"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.synthesizeValue = void 0;
var synthesizeArray_1 = require("./synthesizeArray");
var synthesizeBoolean_1 = require("./synthesizeBoolean");
var synthesizeNumber_1 = require("./synthesizeNumber");
var synthesizeObject_1 = require("./synthesizeObject");
var synthesizeString_1 = require("./synthesizeString");
function synthesizeValue(schema, options) {
    var random = options.random;
    try {
        if (typeof schema === 'boolean') {
            return {};
        }
        if ('example' in schema) {
            return schema.example;
        }
        if ('examples' in schema && schema.examples.length > 0) {
            return schema.examples[0];
        }
        if ('default' in schema) {
            return schema["default"];
        }
        if ('enum' in schema && Array.isArray(schema["enum"])) {
            return schema["enum"][Math.floor(schema["enum"].length * random())];
        }
        if (!('type' in schema)) {
            return {};
        }
        if (Array.isArray(schema.type)) {
            var type = schema.type[Math.floor(schema.type.length * random())];
            return synthesizeValue(__assign(__assign({}, schema), { type: type }), options);
        }
        if (schema.type === 'object') {
            return (0, synthesizeObject_1.synthesizeObject)(schema, options);
        }
        if (schema.type === 'array') {
            return (0, synthesizeArray_1.synthesizeArray)(schema, options);
        }
        if (schema.type === 'integer' || schema.type === 'number') {
            return (0, synthesizeNumber_1.synthesizeNumber)(schema, options);
        }
        if (schema.type === 'string') {
            return (0, synthesizeString_1.synthesizeString)(schema, options);
        }
        if (schema.type === 'boolean') {
            return (0, synthesizeBoolean_1.synthesizeBoolean)(schema, options);
        }
        if (schema.type === 'null') {
            return null;
        }
        return {};
    }
    catch (_a) {
        return {};
    }
}
exports.synthesizeValue = synthesizeValue;
